import cn from 'classnames';

import BangBangSalmon from 'images/bang-bang-salmon.png';
import KoreanBbqPulledPork from 'images/korean-bbq-pulled-pork.png';
import NavyWaveBorder from 'images/tempoNavyWaveBorder.svg';

const MyHealthyDishImageSection = () => {
  return (
    <>
      <div
        style={{ backgroundImage: `url(${NavyWaveBorder})` }}
        className="-mt-px h-12 bg-repeat-x p-0 bp1:mb-8"
      />
      <div>
        <img
          className={cn(
            'absolute bp1:inset-1/2 bp1:top-28 bp1:translate-x-80',
            'bp3:top-22 -right-10 -top-8 w-36 rotate-[12deg] bp1:-right-6 bp1:w-44'
          )}
          src={BangBangSalmon}
          alt="Bang Bang Salmon"
        />
        <img
          className={cn(
            'absolute bp1:inset-1/2 bp1:top-28 bp1:w-40 bp1:-translate-x-[32rem]',
            'bp3:top-22 -left-[4.5rem] -top-4 w-36 rotate-[-12deg] bp1:rotate-0'
          )}
          src={KoreanBbqPulledPork}
          alt="Korean BBQ Pulled Pork"
        />
      </div>
    </>
  );
};

export default MyHealthyDishImageSection;
